import _ from "lodash";
import moment from 'moment';

export const roundNum = function(val, decimalPlaces) {
  const multiplier = Math.pow(10, decimalPlaces || 0);
  return Math.round(val * multiplier) / multiplier;
};

export const calculateAllocation = function(store, dates, allocation) {
  _.forEach(dates, function(date, index) {
    if (allocation[index] && _.isFinite(allocation[index]) && allocation[index] >= 0) {
      store[date] = store[date] || [];
      store[date].push(roundNum(allocation[index], 1));
    }
  });
  const currentAlloc = {};
  _.forEach(store, function(val, key) {
    currentAlloc[key] = val.length === 0 ? 0 : _.reduce(val, function(sum, n) {
      return sum + n;
    }, 0) / val.length;
  });
  return currentAlloc;
};

export const calculateHighchartsAllocation = function(data) {
  const highchartsData = [];
  let firstWeek;
  _.forEach(data, function(val, date) {
    const dayOfWeek = moment(date).isoWeekday() - 1;
    const weeks = moment(date).isoWeek();
    firstWeek = firstWeek || weeks;
    highchartsData.push([dayOfWeek, weeks - firstWeek, roundNum(val, 1)]);
  });
  return highchartsData;
};

export const calculateDatesAsWeeks = function(dates) {
  let lowestWeek, highestWeek;
  _.forEach(dates, function(d) {
    const currentIsoWeek = moment(d).isoWeek();
    if (!lowestWeek || lowestWeek > currentIsoWeek) {
      lowestWeek = currentIsoWeek;
    }
    if (!highestWeek || highestWeek < currentIsoWeek) {
      highestWeek = currentIsoWeek;
    }
  });
  const weekLabels = [];
  for (let i = lowestWeek; i <= highestWeek; i++) {
    const startDate = moment().isoWeek(i).startOf("isoWeek").format("YYYY-MM-DD");
    const endDate = moment().isoWeek(i).endOf("isoWeek").format("YYYY-MM-DD");
    weekLabels.push(startDate + " -<br> " + endDate);
  }
  return weekLabels;
};